import * as React from "react"

import {
  EPL_EXCLUDE_ITEMS_BY_FILE_MODAL_HIDE,
  EPL_EXCLUDE_ITEMS_BY_FILE_MODAL_SHOW,
  EPL_ITEMS_EXCLUDED_RESET_ALL_MODAL_HIDE,
  EPL_ITEMS_EXCLUDED_RESET_ALL_MODAL_SHOW,
  EPL_MARKET_CLOSE_MODAL_HIDE,
  EPL_MARKET_CLOSE_MODAL_SHOW,
  EPL_MARKET_OPEN_MODAL_HIDE,
  EPL_MARKET_OPEN_MODAL_SHOW,
  EPL_MARKET_PAUSE_MODAL_HIDE,
  EPL_MARKET_PAUSE_MODAL_SHOW,
  EPL_MARKET_RESUME_MODAL_HIDE,
  EPL_MARKET_RESUME_MODAL_SHOW,
  EPL_MODEL_HINTS_MODAL_HIDE,
  EPL_MODEL_HINTS_MODAL_SHOW,
  EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_HIDE,
  EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_SHOW,
  EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_HIDE,
  EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_SHOW,
  EPL_PLAN_OPT_OUT_MODAL_HIDE,
  EPL_PLAN_OPT_OUT_MODAL_SHOW,
  EPL_PROMOTE_EXCLUSIVELY_MODAL_HIDE,
  EPL_PROMOTE_EXCLUSIVELY_MODAL_SHOW,
  EPL_RESUBSCRIBE_MODAL_HIDE,
  EPL_RESUBSCRIBE_MODAL_SHOW,
  EPL_UPSELL_MODAL_HIDE,
  EPL_UPSELL_MODAL_SHOW,
  EPL_MODEL_LAST_MARKET_CLOSE_SHOW,
  EPL_MODEL_LAST_MARKET_CLOSE_HIDE,
  EPL_PLA_SURVEY_MODAL_SHOW,
  EPL_PLA_SURVEY_MODAL_HIDE,
} from "data/constants"

const EplModalsContext = React.createContext()

function eplModalsReducer(state, action) {
  switch (action.type) {
    case EPL_RESUBSCRIBE_MODAL_SHOW:
      return {
        ...state,
        showResubscribeModal: { status: true, data: action?.data },
      }
    case EPL_RESUBSCRIBE_MODAL_HIDE:
      return { ...state, showResubscribeModal: { status: false } }
    case EPL_PLAN_OPT_OUT_MODAL_SHOW:
      return { ...state, showOptOutModal: { status: true, data: action?.data } }
    case EPL_PLAN_OPT_OUT_MODAL_HIDE:
      return { ...state, showOptOutModal: { status: false } }
    case EPL_MARKET_CLOSE_MODAL_SHOW:
      return {
        ...state,
        showMarketCloseModal: { status: true, data: action?.data },
      }
    case EPL_MARKET_CLOSE_MODAL_HIDE:
      return { ...state, showMarketCloseModal: { status: false } }
    case EPL_MARKET_RESUME_MODAL_SHOW:
      return {
        ...state,
        showMarketResumeModal: { status: true, data: action?.data },
      }
    case EPL_MARKET_RESUME_MODAL_HIDE:
      return { ...state, showMarketResumeModal: { status: false } }
    case EPL_MARKET_PAUSE_MODAL_SHOW:
      return {
        ...state,
        showMarketPauseModal: { status: true, data: action?.data },
      }
    case EPL_MARKET_PAUSE_MODAL_HIDE:
      return { ...state, showMarketPauseModal: { status: false } }
    case EPL_MARKET_OPEN_MODAL_SHOW:
      return {
        ...state,
        showMarketOpenModal: { status: true, data: action?.data },
      }
    case EPL_MARKET_OPEN_MODAL_HIDE:
      return { ...state, showMarketOpenModal: { status: false } }
    case EPL_EXCLUDE_ITEMS_BY_FILE_MODAL_SHOW:
      return {
        ...state,
        showItemsExcludeByFileModal: { status: true, data: action?.data },
      }
    case EPL_EXCLUDE_ITEMS_BY_FILE_MODAL_HIDE:
      return { ...state, showItemsExcludeByFileModal: { status: false } }
    case EPL_ITEMS_EXCLUDED_RESET_ALL_MODAL_SHOW:
      return {
        ...state,
        showItemsExcludeResetAllModal: { status: true, data: action?.data },
      }
    case EPL_ITEMS_EXCLUDED_RESET_ALL_MODAL_HIDE:
      return { ...state, showItemsExcludeResetAllModal: { status: false } }
    case EPL_UPSELL_MODAL_SHOW:
      return { ...state, showUpsellModal: { status: true, data: action?.data } }
    case EPL_UPSELL_MODAL_HIDE:
      return { ...state, showUpsellModal: { status: false } }
    case EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_SHOW:
      return {
        ...state,
        showNotEligibleModalForAll: { status: true, data: action?.data },
      }
    case EPL_NOT_ELIGIBLE_MODAL_FOR_ALL_HIDE:
      return { ...state, showNotEligibleModalForAll: { status: false } }
    case EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_SHOW:
      return {
        ...state,
        showNotEligibleModalForSome: { status: true, data: action?.data },
      }
    case EPL_NOT_ELIGIBLE_MODAL_FOR_SOME_HIDE:
      return { ...state, showNotEligibleModalForSome: { status: false } }
    case EPL_PROMOTE_EXCLUSIVELY_MODAL_SHOW:
      return {
        ...state,
        showPromoteExclusivelyConfirmationModal: {
          status: true,
          data: action?.data,
        },
      }
    case EPL_PROMOTE_EXCLUSIVELY_MODAL_HIDE:
      return {
        ...state,
        showPromoteExclusivelyConfirmationModal: { status: false },
      }
    case EPL_MODEL_HINTS_MODAL_SHOW:
      return {
        ...state,
        showModelHintsModal: { status: true },
      }
    case EPL_MODEL_HINTS_MODAL_HIDE:
      return {
        ...state,
        showModelHintsModal: { status: false },
      }
    case EPL_MODEL_LAST_MARKET_CLOSE_SHOW:
      return {
        ...state,
        showLastMarketCloseModal: { status: true, data: action?.data },
      }
    case EPL_MODEL_LAST_MARKET_CLOSE_HIDE:
      return {
        ...state,
        showLastMarketCloseModal: { status: false },
      }

    case EPL_PLA_SURVEY_MODAL_SHOW:
      return {
        ...state,
        showPLASurveyModal: { status: true },
      }
    case EPL_PLA_SURVEY_MODAL_HIDE:
      return {
        ...state,
        showPLASurveyModal: { status: false },
      }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function EplModalsContextProvider({ children }) {
  const [state, dispatch] = React.useReducer(eplModalsReducer, {
    showOptOutModal: { status: false },
    showResubscribeModal: { status: false },
    showMarketOpenModal: { status: false },
    showMarketCloseModal: { status: false },
    showMarketResumeModal: { status: false },
    showMarketPauseModal: { status: false },
    showItemsExcludeByFileModal: { status: false },
    showItemsExcludeResetAllModal: { status: false },
    showUpsellModal: { status: false },
    showNotEligibleModalForAll: { status: false },
    showNotEligibleModalForSome: { status: false },
    showPromoteExclusivelyConfirmationModal: { status: false },
    showPLAFeedbackModal: { status: false },
    showModelHintsModal: { status: false },
    showLastMarketCloseModal: { status: false },
    showPLASurveyModal: { status: false },
  })
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = { state, dispatch }
  return (
    <EplModalsContext.Provider value={value}>
      {children}
    </EplModalsContext.Provider>
  )
}

function useEplModalsContext() {
  const context = React.useContext(EplModalsContext)
  if (context === undefined) {
    throw new Error(
      "useEplModalsContext must be used within the EplModalsContextProvider"
    )
  }
  return context
}

export { EplModalsContextProvider, useEplModalsContext }
